import React, { useState } from 'react';
import { useAuth } from '../lib/auth';
import { api, apiError } from '../lib/api';

export default function Profile() {
  const { user, refresh } = useAuth();
  const [form, setForm] = useState({ name: user?.name || '', phone: user?.phone || '', avatar_url: user?.avatar_url || '' });
  const [pw, setPw] = useState({ current_password:'', new_password:'' });
  const [msg, setMsg] = useState(''); const [err, setErr] = useState('');
  const [pwMsg, setPwMsg] = useState(''); const [pwErr, setPwErr] = useState('');

  const save = async (e) => {
    e.preventDefault(); setMsg(''); setErr('');
    try { await api.put('/auth/profile', form); await refresh(); setMsg('Profile updated'); }
    catch (e) { setErr(apiError(e)); }
  };

  const changePw = async (e) => {
    e.preventDefault(); setPwMsg(''); setPwErr('');
    try { await api.post('/auth/change-password', pw); setPwMsg('Password changed'); setPw({ current_password:'', new_password:'' }); }
    catch (e) { setPwErr(apiError(e)); }
  };

  return (
    <div data-testid="profile-page">
      <h2 className="mb-3">My profile</h2>
      <div className="row g-3">
        <div className="col-lg-6">
          <div className="ap-card">
            <h4>Personal details</h4>
            {msg && <div className="alert alert-success">{msg}</div>}
            {err && <div className="alert alert-danger">{err}</div>}
            <form onSubmit={save} data-testid="profile-form">
              <label className="form-label">Name</label>
              <input className="form-control mb-2" value={form.name} onChange={e=>setForm({...form,name:e.target.value})} data-testid="profile-name"/>
              <label className="form-label">Phone</label>
              <input className="form-control mb-2" value={form.phone||''} onChange={e=>setForm({...form,phone:e.target.value})} data-testid="profile-phone"/>
              <label className="form-label">Avatar URL</label>
              <input className="form-control mb-3" value={form.avatar_url||''} onChange={e=>setForm({...form,avatar_url:e.target.value})} data-testid="profile-avatar"/>
              <button className="btn-ap" data-testid="profile-save">Save</button>
            </form>
            <div className="mt-3 small text-muted-2">Email: {user?.email} · Role: <strong>{user?.role}</strong></div>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="ap-card">
            <h4>Change password</h4>
            {pwMsg && <div className="alert alert-success">{pwMsg}</div>}
            {pwErr && <div className="alert alert-danger">{pwErr}</div>}
            <form onSubmit={changePw} data-testid="password-form">
              <label className="form-label">Current password</label>
              <input className="form-control mb-2" type="password" value={pw.current_password} onChange={e=>setPw({...pw, current_password:e.target.value})} required data-testid="pw-current"/>
              <label className="form-label">New password (6+ chars)</label>
              <input className="form-control mb-3" type="password" value={pw.new_password} onChange={e=>setPw({...pw, new_password:e.target.value})} required data-testid="pw-new"/>
              <button className="btn-ap" data-testid="pw-submit">Change password</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
